/**
 * .tpo_modal-container が遅延挿入されたあとに、
 * ・外側 div.tpo-modal-injected-close-wrap ＋ 内側 button.tpo-modal-injected-close
 * ・.tpo_modal-container の直後（兄弟）に div.tpo-modal-injected-below
 * ・.tpo_modal-container 直下の**すべての子**を div.tpo-modal-injected-inner-wrap で囲う（TPO 追加入力は随時取り込み）
 * ・「対応径」モーダル時は .tpo-modal-injected-inner-wrap 直下に div.tpo-modal-mm-label を挿入
 * を付与する。
 * 閉じる処理は TPO の実装に合わせて複数手段を順に試す（要調整時は tryCloseModal 内を編集）。
 */
(function () {
	'use strict';

	var BTN_CLASS = 'tpo-modal-injected-close';
	var WRAP_CLASS = 'tpo-modal-injected-close-wrap';
	/** コンテナの外側、DOM 直後（次の兄弟）に挿入する用フック */
	var BELOW_CLASS = 'tpo-modal-injected-below';
	/** コンテナ内の既存子を一括で包む用（閉じる・TPO 本体の両方を内包） */
	var INNER_WRAP_CLASS = 'tpo-modal-injected-inner-wrap';
	var MM_ROW_CLASS = 'tpo-modal-mm-row';

	function findModalRoot(container) {
		return (
			container.closest('dialog') ||
			container.closest('[role="dialog"]') ||
			container.parentElement ||
			document.body
		);
	}

	function tryCloseModal(container) {
		var dialog = container.closest('dialog');
		if (dialog && typeof dialog.close === 'function' && dialog.open) {
			dialog.close();
			return;
		}

		var root = findModalRoot(container);
		var ev = new KeyboardEvent('keydown', {
			key: 'Escape',
			code: 'Escape',
			keyCode: 27,
			which: 27,
			bubbles: true,
			cancelable: true,
		});
		if (root && root.dispatchEvent) {
			root.dispatchEvent(ev);
		}
		document.dispatchEvent(ev);

		var appClose = container.querySelector('.button-modal');
		if (appClose && !appClose.classList.contains(BTN_CLASS)) {
			appClose.click();
			return;
		}

		var selectors = [
			'button[aria-label*="閉"]',
			'button[aria-label*="close" i]',
			'button[type="button"][class*="close"]',
			'[data-dismiss="modal"]',
		];
		for (var s = 0; s < selectors.length; s++) {
			var nodes = root.querySelectorAll(selectors[s]);
			for (var i = nodes.length - 1; i >= 0; i--) {
				var el = nodes[i];
				if (el.classList.contains(BTN_CLASS)) continue;
				el.click();
				return;
			}
		}
	}

	function injectCloseButton(container) {
		if (!container || container.querySelector('.' + BTN_CLASS)) return;

		var wrap = document.createElement('div');
		wrap.className = WRAP_CLASS;

		var btn = document.createElement('button');
		btn.type = 'button';
		btn.className = BTN_CLASS;
		btn.setAttribute('aria-label', '閉じる');
		var iconUrl = typeof window !== 'undefined' && window.TPO_MODAL_CLOSE_ICON_URL;
		if (iconUrl) {
			var img = document.createElement('img');
			img.src = iconUrl;
			img.alt = '';
			img.width = 46;
			img.height = 46;
			img.setAttribute('decoding', 'async');
			btn.appendChild(img);
		} else {
			btn.textContent = '閉じる';
		}
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			tryCloseModal(container);
		});

		wrap.appendChild(btn);
		container.insertBefore(wrap, container.firstChild);
	}

	/**
	 * .tpo_modal-container の**直後**（閉じタグの外・次の兄弟）に空 div を置く。スタイル用のフック。
	 * コンテナ**内**の末尾に入れたい場合は insertAdjacentElement を 'beforeend' に、または appendChild に変更。
	 */
	function injectBelowContainer(container) {
		if (!container) return;
		var next = container.nextElementSibling;
		if (next && next.classList && next.classList.contains(BELOW_CLASS)) return;
		var below = document.createElement('div');
		below.className = BELOW_CLASS;
		container.insertAdjacentElement('afterend', below);
	}

	/**
	 * 「対応径」モーダル向け: 「mm」ラベルを .tpo-modal-injected-inner-wrap の直下に置く。
	 * TPO の DOM（.tpo_modal-heading + .tpo_modal-content）がある場合のみ実行。
	 */
	function injectMmLabel(container) {
		if (!container) return;
		var inner = container.querySelector('.' + INNER_WRAP_CLASS);
		if (!inner) return;

		var heading = inner.querySelector('.tpo_modal-heading');
		var content = inner.querySelector('.tpo_modal-content');
		if (!heading || !content) return;
		if (!/対応径/.test(heading.textContent || '')) return;

		/* 旧構造（.tpo-modal-mm-row 内）からの移行 */
		var oldRow = inner.querySelector(':scope > .' + MM_ROW_CLASS);
		if (oldRow) {
			var oldMm = oldRow.querySelector('.tpo-modal-mm-label');
			if (oldMm) oldMm.remove();
			while (oldRow.firstChild) {
				inner.insertBefore(oldRow.firstChild, oldRow);
			}
			oldRow.remove();
			content = inner.querySelector('.tpo_modal-content');
			if (!content) return;
		}

		var existing = null;
		for (var c = inner.firstElementChild; c; c = c.nextElementSibling) {
			if (c.classList && c.classList.contains('tpo-modal-mm-label')) {
				existing = c;
				break;
			}
		}
		if (existing) {
			if (existing.nextElementSibling !== content) {
				inner.insertBefore(existing, content);
			}
			return;
		}

		var mm = document.createElement('div');
		mm.className = 'tpo-modal-mm-label';
		mm.setAttribute('aria-hidden', 'true');
		mm.textContent = 'mm';
		inner.insertBefore(mm, content);
	}

	/**
	 * .tpo_modal-container の**直下**にある子ノードを、すべて1つの内側 div にまとめる。
	 * 既に内側ラッパーがある場合は、あとから直下に来た子だけ中へ取り込む（TPO 遅延挿入向け）。
	 * ※ 必ず injectCloseButton の**後**、injectMmLabel の**前**に呼ぶ（閉じるボタンも内包するため）。
	 */
	function ensureInnerContentWrap(container) {
		if (!container) return;
		var children = [];
		for (var n = container.firstChild; n; n = n.nextSibling) {
			children.push(n);
		}
		var inner = null;
		for (var j = 0; j < children.length; j++) {
			var node = children[j];
			if (node.nodeType === 1 && node.classList && node.classList.contains(INNER_WRAP_CLASS)) {
				inner = node;
				break;
			}
		}
		if (!inner) {
			inner = document.createElement('div');
			inner.className = INNER_WRAP_CLASS;
			for (var k = 0; k < children.length; k++) {
				inner.appendChild(children[k]);
			}
			container.appendChild(inner);
			return;
		}
		for (var m = 0; m < children.length; m++) {
			if (children[m] !== inner) {
				inner.appendChild(children[m]);
			}
		}
	}

	function enhanceModalScroll(container) {
		if (!container) return;
		var content = container.querySelector('.tpo_modal-content');
		if (!content) return;
		content.setAttribute('data-lenis-prevent', '');
		content.setAttribute('data-lenis-prevent-touch', '');
		if (!content.hasAttribute('tabindex')) {
			content.setAttribute('tabindex', '0');
		}
	}

	function scanAll() {
		document.querySelectorAll('.tpo_modal-container').forEach(function (el) {
			injectCloseButton(el);
			injectBelowContainer(el);
			ensureInnerContentWrap(el);
			injectMmLabel(el);
			enhanceModalScroll(el);
		});
	}

	/**
	 * TPO が付与する `span.form__label.tpo_undefined` のうち、文言が「ブラケットの長さ」のときスタイリング用クラスを追加する。
	 * 祖先の `.tpo_option-label` にもペアのクラスを付与する（レイアウトは親でまとめたい場合用）。
	 */
	var BRACKET_LENGTH_LABEL_TEXT = 'ブラケットの長さ';
	var BRACKET_LENGTH_LABEL_CLASS = 'form__label--bracket-length';
	var BRACKET_LENGTH_OPTION_LABEL_CLASS = 'tpo_option-label--bracket-length';
	var HELP_RIGHT_OPTION_LABEL_CLASS = 'tpo_option-label--help-right';

	function markBracketLengthTpoLabels() {
		document.querySelectorAll('span.form__label.tpo_undefined').forEach(function (el) {
			if ((el.textContent || '').trim() !== BRACKET_LENGTH_LABEL_TEXT) return;
			if (!el.classList.contains(BRACKET_LENGTH_LABEL_CLASS)) {
				el.classList.add(BRACKET_LENGTH_LABEL_CLASS);
			}
			var optionLabelWrap = el.closest('.tpo_option-label');
			if (optionLabelWrap && !optionLabelWrap.classList.contains(BRACKET_LENGTH_OPTION_LABEL_CLASS)) {
				optionLabelWrap.classList.add(BRACKET_LENGTH_OPTION_LABEL_CLASS);
			}
		});
	}

	/**
	 * .tpo_option-help-text 内に「右」を含む場合、同階層の .tpo_option-label-container を持つ親 .tpo_option-label にクラスを付与
	 * CSS 側で .tpo_option-label--help-right > .tpo_option-label-container をターゲットにする。
	 */
	function markRightHelpTextOptionLabels() {
		document.querySelectorAll('.tpo_option-label').forEach(function (optionLabel) {
			var hasRight = false;
			optionLabel.querySelectorAll('.tpo_option-help-text').forEach(function (helpText) {
				if ((helpText.textContent || '').indexOf('右') !== -1) hasRight = true;
			});
			optionLabel.classList.toggle(HELP_RIGHT_OPTION_LABEL_CLASS, hasRight);
		});
	}

	function scanAllAndTpoLabels() {
		scanAll();
		markBracketLengthTpoLabels();
		markRightHelpTextOptionLabels();
	}

	var scheduled = false;
	function scheduleScan() {
		if (scheduled) return;
		scheduled = true;
		requestAnimationFrame(function () {
			scheduled = false;
			scanAllAndTpoLabels();
		});
	}

	var observer = new MutationObserver(scheduleScan);
	observer.observe(document.documentElement, { childList: true, subtree: true });

	/* 親モーダルへスクロールが奪われないよう、.tpo_modal-content 内だけで wheel / touch を処理 */
	document.addEventListener(
		'wheel',
		function (e) {
			var scrollEl = e.target.closest('.tpo_modal-content');
			if (!scrollEl) return;
			var max = scrollEl.scrollHeight - scrollEl.clientHeight;
			if (max <= 0) return;
			var atTop = scrollEl.scrollTop <= 0;
			var atBottom = scrollEl.scrollTop >= max;
			if ((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)) return;
			e.stopPropagation();
		},
		{ passive: true, capture: true }
	);
	document.addEventListener(
		'touchmove',
		function (e) {
			if (e.target.closest('.tpo_modal-content')) {
				e.stopPropagation();
			}
		},
		{ passive: true, capture: true }
	);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scanAllAndTpoLabels);
	} else {
		scanAllAndTpoLabels();
	}
})();
